var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.675 34.9C19.225 35.725 20.05 36 20.875 36C21.7 36 22.525 35.725 23.075 34.9L35.45 18.4C36.275 17.3 36 15.375 34.9 14.55C33.8 13.725 31.875 14 31.05 15.1L20.875 28.575L18.95 26.1C18.125 25 16.2 24.725 15.1 25.55C14 26.375 13.725 28.3 14.55 29.4L18.675 34.9Z",
    fill: "url(#paint0_linear_232_4013)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49.75C38.75 49.75 49.75 38.75 49.75 25C49.75 11.25 38.75 0.25 25 0.25C11.25 0.25 0.25 11.25 0.25 25C0.25 38.75 11.25 49.75 25 49.75ZM25 5.75C35.725 5.75 44.25 14.275 44.25 25C44.25 35.725 35.725 44.25 25 44.25C14.275 44.25 5.75 35.725 5.75 25C5.75 14.275 14.275 5.75 25 5.75Z",
    fill: "url(#paint1_linear_232_4013)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_232_4013",
    x1: 35.9297,
    y1: 14.0703,
    x2: 13.5136,
    y2: 14.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_232_4013",
    x1: 49.75,
    y1: 0.25,
    x2: -1.01055,
    y2: 1.57829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.a9a4d1a3592012411c08c29685d189a2.svg";
export { ForwardRef as ReactComponent };